module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CV-72421dcbfa72a0824d8a276800dfdbe2.png";